module.exports = __webpack_public_path__ + "static/media/team_2.11ada9f5.jpg";